<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 微信质检分析 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <FilterCommon ref="filter" :model="filterModel" :isAdd="true" :isReset="true" @add="add" @search="search" @reset="reset">
          <template v-slot:button>
            <el-button type="primary" @click="handleClickLeadIn">导入</el-button>
            <el-button type="primary" @click="searchFault">我的出错情况</el-button>
            <el-button type="primary" @click="handleSure(0)">确认</el-button>
            <el-button type="primary" @click="handleSure(1)">确认所有</el-button>
          </template>
        </FilterCommon>
        <el-table border @selection-change="handleSelectionChange" v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000" :row-class-name="tableRowClassName">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="err_at" label="出错时间" width="180" />
          <el-table-column prop="data_status_text" label="状态" width="180">
            <template slot="header">
              <span>状态</span>
              <statePopover />
            </template>
          </el-table-column>
          <el-table-column prop="err_admin_name" label="微信客服" width="150" />
          <el-table-column prop="wx_chat_count" label="微信会话量" width="150" />
          <el-table-column prop="chosen_count" label="抽检量" width="150" />
          <el-table-column prop="wrong_count" label="出错数" width="150" />
          <el-table-column prop="err_title" label="出错问题" width="250" />
          <el-table-column prop="err_content" label="出错点" width="250" />
          <el-table-column prop="first_appeal_content" label="申诉原因" width="250">
            <template slot-scope="scope">
              <el-link type="primary" @click="getAppealListFirst(scope.row)">{{ scope.row.first_appeal_content }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="approval_remark" label="审批说明" width="250">
            <template slot-scope="scope">
              <el-link type="primary" @click="getAuditList(scope.row)">{{ scope.row.approval_remark }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="non_first_appeal_content" label="二次申诉原因" width="250">
            <template slot-scope="scope">
              <el-link type="primary" @click="getAppealList(scope.row)">{{ scope.row.non_first_appeal_content }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="approval_admin_name" label="审批人" width="250" />
          <!-- <el-table-column prop="analysis" label="质检分析" width="250" />
          <el-table-column prop="feedback" label="组长反馈" width="250" />
          <el-table-column prop="suggestion" label="可优化点" width="250" /> -->
          <el-table-column label="操作" width="400" fixed="right">
            <template slot-scope="scope">
              <div class="button-area">
                <el-button size="mini" v-if="topTagButton" :type="scope.row.is_top ? 'warning' : 'primary'" @click="handleTop(scope.row.id)">{{ scope.row.is_top ? '取消置顶' : '置顶' }}</el-button>
                <el-button size="mini" v-if="topTagButton" :type="scope.row.is_tag ? 'warning' : 'primary'" @click="handleTag(scope.row.id)">{{ scope.row.is_tag ? '取消标记' : '标记' }}</el-button>
                <el-button size="mini" v-if="updateButton" type="primary" @click="edit(scope.row)">编辑</el-button>
                <el-popover v-if="deleteButton" placement="top" width="160" v-model="scope.row.deleteVisible">
                  <p>确定删除吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="scope.row.deleteVisible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="del(scope.row)">确定</el-button>
                  </div>
                  <el-button slot="reference" size="mini" type="danger" style="margin: 0 10px">删除</el-button>
                </el-popover>
                <el-button size="mini" type="danger" @click="openAppeal(scope.row)" v-if="scope.row.appeal_button">申诉</el-button>
                <el-button size="mini" type="danger" @click="openAudit(scope.row)" v-if="scope.row.approval_button">审核</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total > 0" :total="total" :page.sync="page" :limit.sync="limit" @pagination="handlePagination" />
      </div>
      <Dialog
        ref="dialog"
        :dialogTitle="dialogTitle"
        :dialogVisible="dialogVisible"
        :dialogModel="dialogModel"
        :rules="rules"
        dialogWidth="700px"
        @submitForm="handleSubmit"
        @closeDialog="closeDialog"
      />
      <el-dialog title="上传文件" :visible.sync="uploadDialogVisible" width="35%">
        <el-upload class="upload-demo" style="text-align: center" action="" :multiple="false" :limit="1" drag :before-upload="handleFileProgress">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            只能上传excel文件 xls xlsx csv格式
            <span style="color: #409eff; cursor: pointer" @click="downLoad">点击可下载文件模板</span>
          </div>
          <div slot="tip" class="el-upload__tip" style="color: #409eff" v-show="!!fileName">{{ '当前选择的文件：' + fileName }}</div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button @click="uploadDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="leadingIn">确定上传</el-button>
        </span>
      </el-dialog>
      <!-- 申诉弹框 -->
      <el-dialog title="申诉" :visible.sync="appeal" width="30%" @close="closeAppeal">
        <el-form ref="appealForm" :model="appealForm" label-width="80px">
          <el-form-item label="申诉原因" required="">
            <el-input type="textarea" :rows="5" :disabled="appealFormDis" v-model="appealForm.appeal_content"></el-input>
          </el-form-item>
          <el-form-item label="申诉图片">
            <ImageUpload :imgList="appealForm.appeal_images" :multiple="true" @upload-state-change="appealUploadState = $event"></ImageUpload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeAppeal">取 消</el-button>
          <el-button v-if="!appealFormDis" type="primary" @click="submitAppeal">确定</el-button>
        </span>
      </el-dialog>
      <!-- 申诉详情弹框 -->
      <el-dialog title="申诉详情" @close="closeAppealDetail" :visible.sync="appealDetail" width="30%">
        <el-table border :data="appealDetailData" style="width: 100%" min-height="200" max-height="1000">
          <el-table-column prop="appeal_content" label="申诉原因" />
          <el-table-column prop="appeal_images" label="申诉图片">
            <template slot-scope="scope">
              <div class="imgList">
                <div v-for="(item, index) in scope.row.appeal_images" :key="index">
                  <el-image :z-index="9999" style="width: 40px; height: 40px" :src="item" :preview-src-list="scope.row.appeal_images"></el-image>
                </div>
              </div> </template
          ></el-table-column>
          <el-table-column prop="created_at" label="申诉时间" />
          <pagination v-show="appealDetailTotal > 0" :total="appealDetailTotal" :page.sync="appealDetailTotalPage" :limit="10" @pagination="changeAppeal" />
        </el-table>
      </el-dialog>
      <!-- 审核弹框 -->
      <el-dialog title="审核" :visible.sync="audit" width="30%" @close="closeAudit">
        <el-form ref="appealForm" :model="auditForm" label-width="80px">
          <el-form-item label="审批意见">
            <el-radio-group v-model="auditForm.data_status">
              <el-radio label="3">待定</el-radio>
              <el-radio label="4">通过</el-radio>
              <el-radio label="5">驳回</el-radio>
              <el-radio label="6">客观原因</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审批说明">
            <el-input type="textarea" :rows="5" v-model="auditForm.approval_remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeAudit">取 消</el-button>
          <el-button type="primary" @click="submitAudit">确定</el-button>
        </span>
      </el-dialog>
      <!-- 审批详情弹框 -->
      <el-dialog title="审核详情" :visible.sync="auditDetail" width="30%" @close="closeAuditDetail">
        <el-table border :data="auditDetailData" style="width: 100%" min-height="200" max-height="1000">
          <el-table-column prop="approval_remark" label="审批说明" />
          <el-table-column prop="approval_admin_name" label="审批人" />
          <el-table-column prop="created_at" label="审批时间" />
          <pagination v-show="auditDetailTotal > 0" :total="auditDetailTotal" :page.sync="auditDetailTotalPage" :limit="10" @pagination="changeAudit" />
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  wechatAnalysisListApi,
  wechatAnalysisAddApi,
  wechatAnalysisEditApi,
  wechatAnalysisTopApi,
  wechatAnalysisTagApi,
  wechatAnalysisDeleteApi,
  wechatAnalysisUploadApi,
  adminUserApprovalList,
  wechatAnalysisAppeal,
  wechatAnalysisAApproval,
  wechatAnalysisEnsure,
  wechatAnalysisApproval,
  wechatAnalysisAppealGet,
} from '@/api/testAnalysis.js';
import Pagination from '@/components/pagination/index';
import Dialog from '@/components/common/Dialog';
import FilterCommon from '@/components/common/Filter';
import WorksnDetail from './components/WorksnDetail';
// 状态弹出框
import statePopover from './components/Popover.vue';
import ImageUpload from '@/components/common/ImageUpload/ImageUpload.vue';
import dayjs from 'dayjs';
import BASE_API from '@/config';
import { normalizeImageList } from '@/utils/imageUpload.js';
import Type from '../faq/type.vue';

export default {
  components: { Pagination, Dialog, FilterCommon, WorksnDetail, statePopover, ImageUpload, Type },
  data() {
    return {
      appeal: false, // 申诉弹框
      appealForm: {
        id: 0,
        appeal_content: '',
        appeal_images: [],
      }, // 申诉表单
      appealFormDis: false,
      appealUploadState: { canSubmit: true },
      audit: false, //审核弹框
      auditForm: {
        id: 0,
        data_status: '',
        approval_remark: '',
      }, // 申诉表单
      page: 1,
      limit: 10,
      total: 0,
      listLoading: false,
      tableData: [],
      dialogTitle: '新增',
      dialogVisible: false,
      workId: '',
      visible: false,
      uploadDialogVisible: false,
      uploadFile: {},
      fileName: '',
      exportFileUrl: BASE_API + 'wechat_analysis_excel_download', // 导出地址
      rules: {
        err_at: [{ required: true, message: '请选择时间', trigger: ['blur', 'change'] }],
        err_admin_name: [{ required: true, message: '请输入微信客服', trigger: ['blur', 'change'] }],
        err_title: [{ required: true, message: '请输入出错问题', trigger: ['blur', 'change'] }],
        err_content: [{ required: true, message: '请输入出错点', trigger: ['blur', 'change'] }],
        wx_chat_count: [{ required: true, message: '请输入微信会话量', trigger: 'blur' }],
        chosen_count: [{ required: true, message: '请输入抽检量', trigger: 'blur' }],
        wrong_count: [{ required: true, message: '请输入出错数', trigger: 'blur' }],
      },
      searchParams: {
        page: 1,
        limit: 10,
        start_date: dayjs(new Date()).format('YYYY-MM-DD'),
        end_date: dayjs(new Date()).format('YYYY-MM-DD'),
      },
      userList: [],
      multipleSelection: [],

      auditDetail: false,
      auditDetailData: [],
      auditDetailTotal: 0,
      auditDetailTotalPage: 1,
      auditDetailId: 0,

      appealDetail: false,
      appealDetailData: [],
      appealDetailTotal: 0,
      appealDetailTotalPage: 0,
      appealDetailId: 0,

      updateButton: false, // 编辑权限 true有 false无
      topTagButton: false, // 置顶与标记权限 true有 false无
      deleteButton: false, // 删除权限
    };
  },
  computed: {
    filterModel() {
      return [
        {
          span: 6,
          type: 'date-picker',
          label: '出错时间：',
          key: 'date',
          dateType: false,
          empty: false,
          pick: true,
          showDefault: true,
        },
        {
          type: 'input',
          label: '微信客服：',
          key: 'err_admin_name',
          placeholder: '请输入',
          span: 4,
        },
        {
          type: 'select',
          label: '状态',
          key: 'data_status',
          placeholder: '请选择',
          span: 4,
          options: [
            {
              value: 0,
              label: '未确认',
            },
            {
              value: 1,
              label: '已确认',
            },
            {
              value: 2,
              label: '未审批',
            },
            {
              value: 3,
              label: '待定',
            },
            {
              value: 4,
              label: '通过',
            },
            {
              value: 5,
              label: '驳回',
            },
            {
              value: 6,
              label: '客观原因',
            },
            {
              value: 7,
              label: '已超时',
            },
          ],
        },
        {
          type: 'select',
          label: '申诉行为',
          key: 'appeal_status',
          placeholder: '请选择',
          span: 4,
          options: [
            {
              value: 0,
              label: '未申诉',
            },
            {
              value: 1,
              label: '一次申诉',
            },
            {
              value: 2,
              label: '二次申诉',
            },
          ],
        },
        {
          type: 'select',
          label: '审批人',
          key: 'approval_admin_id',
          placeholder: '请选择',
          span: 4,
          options: this.userList,
        },
      ];
    },
    dialogModel() {
      return [
        {
          type: 'el-date-picker',
          label: '出错时间',
          prop: 'err_at',
          format: 'yyyy-MM-dd HH:mm:ss',
        },
        {
          type: 'el-input',
          label: '微信客服',
          prop: 'err_admin_name',
        },
        {
          type: 'el-input-number',
          label: '微信会话量',
          prop: 'wx_chat_count',
          min: 0,
        },
        {
          type: 'el-input-number',
          label: '抽检量',
          prop: 'chosen_count',
          min: 0,
        },
        {
          type: 'el-input-number',
          label: '出错数',
          prop: 'wrong_count',
          min: 0,
        },
        {
          type: 'el-input',
          label: '出错问题',
          prop: 'err_title',
        },
        {
          type: 'el-input-textarea',
          label: '出错点',
          prop: 'err_content',
          maxlength: 200,
          showWordLimit: true,
          autoSize: { minRows: 3, maxRows: 6 },
        },
        // {
        //   type: 'el-input-textarea',
        //   label: '质检分析',
        //   prop: 'analysis',
        //   maxlength: 200,
        //   showWordLimit: true,
        //   autoSize: { minRows: 3, maxRows: 6 },
        // },
        // {
        //   type: 'el-input-textarea',
        //   label: '组长反馈',
        //   prop: 'feedback',
        //   maxlength: 200,
        //   showWordLimit: true,
        //   autoSize: { minRows: 3, maxRows: 6 },
        // },
        // {
        //   type: 'el-input-textarea',
        //   label: '可优化点',
        //   prop: 'suggestion',
        //   maxlength: 200,
        //   showWordLimit: true,
        //   autoSize: { minRows: 3, maxRows: 6 },
        // },
      ];
    },
  },
  created() {
    this.getTableList();
    this.getUserList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 打开申诉
    openAppeal(row) {
      this.appealForm.id = row.id;
      this.appealForm.appeal_content = '';
      this.appealForm.appeal_images = [];
      this.appealUploadState = { canSubmit: true };
      this.appeal = true;
    },
    // 关闭申诉
    closeAppeal() {
      this.appeal = false;
      this.appealForm.id = 0;
      this.appealForm.appeal_content = '';
      this.appealForm.appeal_images = [];
      this.appealFormDis = false;
    },
    // 提交申诉
    async submitAppeal() {
      if (!this.appealUploadState.canSubmit) {
        this.$message.warning(this.appealUploadState.failedCount ? '有图片上传失败，请移除后重新选择' : '图片正在上传，请稍后');
        return;
      }
      const data = { id: this.appealForm.id, appeal_content: this.appealForm.appeal_content, appeal_images: this.appealForm.appeal_images.map((m) => m.url) };
      const r = await wechatAnalysisAppeal(data);
      if (r.data.code !== 200) {
        this.$message.error(r.data.message);
      } else {
        this.$message.success('提交成功');
      }
      this.closeAppeal();
      this.getTableList();
    },
    // 打开审核
    openAudit(row) {
      this.auditForm.id = row.id;
      this.auditForm.data_status = '';
      this.auditForm.approval_remark = '';
      this.audit = true;
    },
    // 关闭审核
    closeAudit() {
      this.audit = false;
      this.auditForm.id = 0;
      this.auditForm.data_status = '';
      this.auditForm.approval_remark = '';
    },
    // 提交审核
    async submitAudit() {
      const r = await wechatAnalysisAApproval(this.auditForm);
      if (r.data.code !== 200) {
        this.$message.error(r.data.message);
      } else {
        this.$message.success('提交成功');
      }
      this.closeAudit();
      this.getTableList();
    },
    // 点击确定
    async handleSure(type) {
      if (type === 0 && this.multipleSelection.length === 0) {
        this.$message.error('请先选择至少一条数据');
        return;
      }
      const data = { all_data: type };
      if (type === 0) {
        Object.assign(data, { id_array: this.multipleSelection.map((m) => m.id) });
      } else {
        Object.assign(data, this.$refs.filter.formData);
      }
      const r = await wechatAnalysisEnsure(data);
      if (r.data.code !== 200) {
        this.$message.error(r.data.message);
      } else {
        this.$message.success('提交成功');
      }
      this.getTableList();
    },
    // 下载模板
    async downLoad() {
      window.open(this.exportFileUrl, '_blank');
    },
    // 获取工单客服列表
    async getUserList() {
      const r = await adminUserApprovalList();
      const list = [...r.data.data];
      this.userList = list.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    },
    // 获取审批详情列表
    async getAuditList(row) {
      const r = await wechatAnalysisApproval({ id: row ? row.id : this.auditDetailId, page: this.auditDetailTotalPage, limit: 10 });
      if (r.data.code !== 200) {
        this.$message.error(r.data.message);
        return;
      }
      this.auditDetail = true;
      this.auditDetailId = row ? row.id : this.auditDetailId;
      this.auditDetailData = r.data.data.data;
      this.auditDetailTotal = r.data.data.total;
    },
    // 关闭审批详情列表
    closeAuditDetail() {
      this.auditDetail = false;
      this.auditDetailId = 0;
      this.auditDetailData = [];
      this.auditDetailTotal = 0;
    },
    // 获取首次申诉详情列表
    async getAppealListFirst(row) {
      this.appealFormDis = true;
      this.appealForm.appeal_content = row.first_appeal_content;
      this.appealForm.appeal_images = normalizeImageList(row.first_appeal_images, 'first-appeal');
      this.appeal = true;
    },
    // 获取二次申诉详情列表
    async getAppealList(row) {
      const r = await wechatAnalysisAppealGet({ id: row ? row.id : this.appealDetailId, page: this.appealDetailTotalPage, limit: 10 });
      if (r.data.code !== 200) {
        this.$message.error(r.data.message);
        return;
      }
      this.appealDetail = true;
      this.appealDetailId = row ? row.id : this.appealDetailId;
      this.appealDetailData = r.data.data.data;
      this.appealDetailTotal = r.data.data.total;
    },
    // 关闭审批详情列表
    closeAppealDetail() {
      this.appealDetail = false;
      this.appealDetailId = 0;
      this.appealDetailData = [];
      this.appealDetailTotal = 0;
    },
    // 获取table列表
    async getTableList() {
      const r = await wechatAnalysisListApi(this.searchParams);
      if (r.data.code != 200) {
        this.$message.error(r.data.message);
        return;
      }
      this.updateButton = r.data.data.update_button;
      this.topTagButton = r.data.data.top_tag_button;
      this.deleteButton = r.data.data.delete_button;
      this.tableData = r.data.data.data;
      this.total = r.data.data.total;
    },
    // 搜索
    search(e, isMyFault) {
      if (!e.start_date) {
        Object.assign(e, {
          start_date: dayjs(new Date()).format('YYYY-MM-DD'),
        });
      }
      if (!e.end_date) {
        Object.assign(e, {
          end_date: dayjs(new Date()).format('YYYY-MM-DD'),
        });
      }
      this.searchParams = Object.assign(this.searchParams, e, { my_fault: !!isMyFault ? 1 : 0 });
      delete this.searchParams.date;
      this.getTableList();
    },
    // 点击我的出错情况搜索
    searchFault() {
      this.search(this.$refs.filter.formData, 1);
    },
    // 重置
    reset() {
      this.searchParams = {
        page: 1,
        limit: 10,
        start_date: dayjs(new Date()).format('YYYY-MM-DD'),
        end_date: dayjs(new Date()).format('YYYY-MM-DD'),
      };
      this.getTableList();
    },
    // 提交新增、编辑表单
    async handleSubmit(form) {
      let r = {};
      if (this.dialogTitle == '新增') {
        r = await wechatAnalysisAddApi(form);
      } else {
        r = await wechatAnalysisEditApi(form);
      }
      if (r.data.code != 200) {
        this.$message.error(r.data.message);
        return;
      }
      this.getTableList();
      this.$message.success('操作成功！');
      this.dialogVisible = false;
    },
    // 点击添加
    add() {
      this.dialogTitle = '新增';
      this.dialogVisible = true;
      this.$refs.dialog.editForm({});
    },
    // 点击编辑
    edit(row) {
      this.dialogTitle = '编辑';
      this.dialogVisible = true;
      this.$refs.dialog.editForm(row);
    },
    // 点击删除
    async del(row) {
      const r = await wechatAnalysisDeleteApi(row.id);
      row.deleteVisible = false;
      if (r.data.code != 200) {
        this.$message.error(r.data.message);
        return;
      }
      this.$message.success('删除成功！');
      this.getTableList();
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    async handleTop(id) {
      const r = await wechatAnalysisTopApi(id);
      this.getTableList();
    },
    async handleTag(id) {
      const r = await wechatAnalysisTagApi(id);
      this.getTableList();
    },
    // 被标记的行背景为粉红色
    tableRowClassName({ row }) {
      if (row.is_tag) {
        return 'warning-row';
      }
      return '';
    },
    // 显示工单详情
    showDetail(workId) {
      this.$refs.worksnDetail.changeVisible(true, workId);
    },
    cancelDrawer() {
      this.$refs.drawer.closeDrawer();
    },
    // 处理翻页
    handlePagination(obj) {
      this.searchParams = Object.assign(this.searchParams, {
        page: obj.page,
        limit: obj.limit,
      });
      this.getTableList();
    },
    changeAudit(obj) {
      this.auditDetailTotalPage = obj.page;
      this.getAuditList();
    },
    changeAppeal(obj) {
      this.appealDetailTotalPage = obj.page;
      this.getAppealList();
    },
    handleFileProgress(file) {
      this.fileName = file.name;
      this.uploadFile = file;
      return false;
    },
    // 点击导入
    async leadingIn() {
      this.listLoading = true;
      const formData = new FormData();
      formData.append('excel_file', this.uploadFile);
      const { data } = await wechatAnalysisUploadApi(formData);
      this.uploadDialogVisible = false;
      this.listLoading = false;
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('上传成功');
      this.getTableList();
    },
    handleClickLeadIn() {
      this.uploadFile = '';
      this.fileName = '';
      this.uploadDialogVisible = true;
    },
  },
};
</script>

<style>
.el-table .warning-row {
  background: rgb(248, 229, 229);
}
.button-area {
  display: flex;
}
</style>
<style lang="scss">
.imgList {
  display: flex;
  justify-content: center;
  > div {
    margin-right: 8px;
  }
}
</style>
